module.exports = __webpack_public_path__ + "img/hdcardlogo.d5b3e1f7.png";